<p class="success-message">
    {{message}}
</p>